import { axiosDelete, axiosGet, axiosPost, axiosPut } from "./instance";

export const apiPublicInit = (callback) => {
    axiosGet("public/init", {}, callback, true);
}

export const apiPublicImpersonate = ({ impersonate }, callback) => {
    axiosGet("public/impersonate", { impersonate }, callback, true);
}

export const apiPublicContact = ({ subject, name, email, phone, message, recaptcha }, callback) => {
    axiosPost("public/contact", { subject, name, email, phone, message, recaptcha }, callback);
}

export const apiPublicGames = ({ seasonId, competitionId, echelonId, latestOnly }, callback) => {
    axiosGet("public/games", { seasonId, competitionId, echelonId, latestOnly }, callback);
}

export const apiPublicGame = ({ gameId }, callback) => {
    axiosGet("public/game", { gameId }, callback);
}

export const apiPublicTeam = ({ seasonId }, callback) => {
    axiosGet("public/team", { seasonId }, callback);
}

export const apiEditMember = ({
    topic,
    personId,
    fullName,
    shortName,
    fiscalNumber,
    email,
    paymentEmail,
    phoneNrMobilePrimary,
    phoneNrMobileSecondary,
    birthDate,
    address,
    town,
    postCode,
    idCardType,
    identificationNumber,
    idCardIssuedBy,
    idCardIssuedAt,
    idCardValidity,
    placeOfBirth,
    nationality,
    job,
    maritalStatus,
    gender,
    fatherName,
    motherName,
    recaptcha
}, callback) => {
    const url = topic === "EXTERNAL" ? "public/edit-member-external" : "public/edit-member";
    const recaptchaParam = topic === "EXTERNAL" ? { recaptcha } : {};
    axiosPost(
        url,
        {
            topic,
            personId,
            fullName,
            shortName,
            fiscalNumber,
            email,
            paymentEmail,
            phoneNrMobilePrimary,
            phoneNrMobileSecondary,
            birthDate,
            address,
            town,
            postCode,
            idCardType,
            identificationNumber,
            idCardIssuedBy,
            idCardIssuedAt,
            idCardValidity,
            placeOfBirth,
            nationality,
            job,
            maritalStatus,
            gender,
            fatherName,
            motherName,
            ...recaptchaParam,
        },
        callback
    );
}

export const apiPublicRequests = ({ impersonate }, callback) => {
    axiosGet("public/requests", { impersonate }, callback);
}

export const apiPublicShopCreate = ({ personId, productId, size, details }, callback) => {
    const formdata = new FormData();
    formdata.append("details", JSON.stringify(Boolean(details) ? details : []));
    axiosPost("public/shop/create", { personId, productId, size, details }, callback, true, formdata);
}

export const apiPublicShopOrderDelete = ({ shopOrderId }, callback) => {
    axiosDelete("public/shop/delete", { shopOrderId }, callback);
}

export const apiPublicShopCheckout = ({ personId }, callback) => {
    axiosPost("public/shop/checkout", { personId }, callback);
}


export const apiPublicOrderItems = ({ orderIdentifier }, callback) => {
    axiosGet("public/shop/order", { orderIdentifier }, callback);
}

export const apiPublicInstagram = (callback) => {
    axiosGet("public/instagram", {}, callback);
}

export const apiPublicSeasonConfirm = ({ personId }, callback) => {
    axiosPut("public/season-confirm", { personId }, callback);
}

export const apiPublicMbwayInfo = ({ paymentReferenceId }, callback, silent = false) => {
    axiosGet("public/mbway-info", { paymentReferenceId }, callback, true, silent);
}

export const apiPublicMbwayRequest = ({ paymentReferenceId, phoneNumber }, callback) => {
    axiosPost("public/mbway-request", { paymentReferenceId, phoneNumber }, callback);
}

export const apiPublicPartners = (callback) => {
    axiosGet("public/partners", {}, callback, true);
}

export const apiPublicStories = (callback) => {
    axiosGet("public/stories", {}, callback, true);
}

export const apiPublicMemberCard = ({ personId, file }, callback) => {
    if (Boolean(file)) {
        const formdata = new FormData();
        formdata.append("photo_content", file);
        axiosPut("public/member-card", { personId }, callback, true, formdata);
    }
}
